import * as React from 'react';
import { Body1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IMapModalHeaderProps {
  /** Кнопки справа — как группа контактов в шапке полноэкранной галереи. */
  buttons?: React.ReactNode;
  testId?: string;
  title: string;
}

/** Шапка модалки с картой — как у полноэкранной галереи: название над всем содержимым. */
export function MapModalHeader({ buttons, testId, title }: IMapModalHeaderProps): React.JSX.Element {
  return (
    <div className={styles['container']} data-testid={testId}>
      <div className={styles['title']}>
        <Body1 fontWeight="700">{title}</Body1>
      </div>
      {buttons && <div className={styles['button-group']}>{buttons}</div>}
    </div>
  );
}
